import { DialogActions, DialogContent, Grid } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { XsBaseDialog, XsButton } from '../../../global/ui';
import WarningDialogStore from './WarningDialogStore';

function WarningDialog() {
  const { t } = useTranslation();

  return (
    <XsBaseDialog
      open={WarningDialogStore.isOpen}
      onClose={() => WarningDialogStore.close()}
      title={t('request_form.warning_dialog_title')}
      maxWidth='sm'
      fullWidth
    >
      <DialogContent>
        <Grid container className='pt-2'>
          <Grid item xs={12}>
            {WarningDialogStore.message}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent='flex-end' style={{ padding: '0 8px 8px' }}>
          <Grid item>
            <XsButton
              label='request_form.warning_ok_button'
              variant='contained'
              icon={<i className='fal fa-check' />}
              onClick={() => WarningDialogStore.close()}
            />
          </Grid>
        </Grid>
      </DialogActions>
    </XsBaseDialog>
  );
}

export default observer(WarningDialog);
